import HttpClient from "@/modules/common/lib/httpClient";

import { NewPasswordSchemaType } from "../common/schemas";

export type ACL =
  | "agents"
  | "agents>statistics"
  | "analytics"
  | "analytics>aac_efficiency"
  | "analytics>answers"
  | "analytics>blocked-opiners"
  | "analytics>cashflow"
  | "analytics>expenses"
  | "analytics>dashboards"
  | "analytics>dashboards>flex"
  | "analytics>heatmap"
  | "analytics>map"
  | "analytics>monitoring-agents-vrf"
  | "analytics>overview"
  | "analytics>users-on-latest"
  | "analytics>users-per-region"
  | "answers"
  | "answers>list"
  | "answers>queue"
  | "answers>approval"
  | "ausers"
  | "ausers>list"
  | "ausers>templates>list"
  | "beacons"
  | "beacons>create"
  | "beacons>list"
  | "beacons>tags"
  | "cashflow"
  | "ceu"
  | "comm"
  | "comm>email"
  | "comm>email>create"
  | "comm>email>list"
  | "comm>email>templates"
  | "comm>push"
  | "comm>push-to-dev"
  | "comm>push>create"
  | "comm>push>list"
  | "courier"
  | "customers"
  | "dashboard"
  | "faq"
  | "faq>tags"
  | "faq>articles"
  | "faq>categories"
  | "locations"
  | "locations>regions"
  | "locations>explorer"
  | "merges"
  | "missions"
  | "missions>create"
  | "missions>create>explorer"
  | "missions>create>geo"
  | "missions>create>virtual"
  | "missions>list"
  | "pdp"
  | "pdp>list"
  | "pdp>create"
  | "qde"
  | "qde>list"
  | "qde>create"
  | "qre"
  | "qre>list"
  | "qre>create"
  | "surveys"
  | "surveys>list"
  | "surveys>create"
  | "reports"
  | "reports>view"
  | "polygons"
  | "projects"
  | "projects>create"
  | "projects>create>audit"
  | "projects>create>other"
  | "projects>create>tree"
  | "projects>list"
  | "sac"
  | "bespoke"
  | "bespoke>uber>pricing"
  | "bespoke>uber>pricing>routes"
  | "bespoke>uber>pricing>review"
  | "bespoke>uber>pricing>batches"
  | "bespoke>uber>pricing>dashboard"
  | "bespoke>uber>structural"
  | "bespoke>uber>structural>answers"
  | "support"
  | "tasks"
  | "users"
  | "users>active_users"
  | "users>activity"
  | "users>balance"
  | "users>filters"
  | "users>frauds"
  | "users>list"
  | "users>queue"
  | "withdrawals"
  | "withdrawals>dashboard"
  | "withdrawals>approval"
  | "withdrawals>errors"
  | "withdrawals>list";

export type ALLOWED_ROLES =
  | "dashboard::view"
  | "analytics::dashboards::flex"
  | "answers_queues::agent_access"
  | "answers::set_queue_priority"
  | "answers::detail"
  | "answers::tracking"
  | "ausers::list"
  | "ausers::create"
  | "ausers::update"
  | "ausers::detail"
  | "ausers::reset_totp"
  | "ausers::templates::list"
  | "ausers::templates::create"
  | "ausers::templates::update"
  | "ausers::password::update"
  | "agents::exports::project"
  | "agents::dashboard::approval"
  | "beacons::list"
  | "beacons::create"
  | "beacons::detail"
  | "beacons::update"
  | "beacons::tags::create"
  | "beacons::tags::update"
  | "beacons::tags::list"
  | "comm::push::list"
  | "comm::push::create"
  | "customers::list"
  | "customers::create"
  | "customers::detail"
  | "customers::update"
  | "customers::set_ccpm"
  | "customers::cacusers::list"
  | "customers::cacusers::create"
  | "customers::cacusers::update"
  | "customers::cacfilters::list"
  | "customers::cacfilters::create"
  | "customers::cacfilters::update"
  | "customers::cacfilters::delete"
  | "customers::sponsorships::list"
  | "customers::sponsorships::create"
  | "customers::sponsorships::detail"
  | "faq::articles::list"
  | "faq::articles::create"
  | "faq::articles::update"
  | "faq::tags::list"
  | "faq::tags::create"
  | "faq::tags::update"
  | "faq::categories::list"
  | "faq::categories::create"
  | "faq::categories::update"
  | "faq::articles::update"
  | "live::detail"
  | "live::update"
  | "locations::regions::list"
  | "locations::regions::create"
  | "locations::regions::detail"
  | "locations::explorer::list"
  | "locations::explorer::create"
  | "locations::explorer::detail"
  | "merged::list"
  | "merged::detail"
  | "missions::detail"
  | "projects::create"
  | "projects::detail"
  | "projects::list"
  | "projects::update"
  | "projects::audit::create"
  | "projects::audit::detail"
  | "projects::audit::list"
  | "projects::audit::update"
  | "projects::controls::approve"
  | "projects::controls::pause"
  | "projects::controls::play"
  | "projects::controls::stop"
  | "projects::dtree::create"
  | "projects::exports::audit"
  | "projects::exports::include_ids"
  | "projects::exports::views"
  | "projects::exports::xlsx"
  | "projects::dashboard"
  | "pdp::list"
  | "pdp::create"
  | "pdp::detail"
  | "pdp::update"
  | "surveys::create"
  | "surveys::detail"
  | "surveys::list"
  | "surveys::update"
  | "qde::create"
  | "qde::detail"
  | "qde::list"
  | "qde::update"
  | "qre::list"
  | "qre::detail"
  | "qre::create"
  | "qre::update"
  | "qre::review"
  | "reports::view"
  | "sp::uber::pricing::routes::list"
  | "sp::uber::structural::answers::list"
  | "sp::uber::structural::answers::sync"
  | "sp::uber::pricing::delivery::dashboard"
  | "sp::uber::pricing::batches::list"
  | "support::tickets::list"
  | "support::exports::refunded"
  | "users::detail"
  | "users::list"
  | "withdrawals::dashboard"
  | "withdrawals::agent_access"
  | "withdrawals::list";

export type IMPLEMENTED_MODULES =
  | "answers"
  | "ausers"
  | "customers"
  | "faq"
  | "live"
  | "locations"
  | "merges"
  | "missions"
  | "spuber"
  | "flexviews"
  | "users"
  | "projects"
  | "beacons"
  | "qde"
  | "qre"
  | "pdp"
  | "withdrawals"
  | "agents"
  | "reports"
  | ALLOWED_ROLES;

export type LoginParams = {
  email: string;
  password: string;
};

type LoginResponse = {
  auth_token: string;
  token_type: string;
  mfa_type: string;
  mfa_enroll: boolean;
  mfa_secret?: string;
  mfa_uri?: string;
};

export type MfaParams = {
  mfa: string;
};

type AuthResponse = {
  access_token: string;
  token_type: string;
};

export type MeResponse = {
  name: string;
  email: string;
  image?: string;
  home?: string;
  lang: string;
  locale: string;
  timezone: string;
  roles: ALLOWED_ROLES[];
  rollback_modules: IMPLEMENTED_MODULES[];
  menu: ACL[];
};

const login = async (params: LoginParams): Promise<LoginResponse> =>
  HttpClient.post(`/auth/login`, params);

const mfaValidate = async (
  params: MfaParams,
  token: string
): Promise<AuthResponse> =>
  HttpClient.post(`/auth/mfa`, params, {
    headers: {
      Authorization: token,
    },
  });

const logout = async (): Promise<void> => HttpClient.get(`/auth/logout`);

const me = async (): Promise<MeResponse> => HttpClient.get(`/me`);

const changePassword = async (data: NewPasswordSchemaType): Promise<void> =>
  HttpClient.put(`/auth/password`, data);

export default {
  me,
  login,
  mfaValidate,
  logout,
  changePassword,
};
